import React, { forwardRef } from 'react';

const Experience = forwardRef((props, ref) => {
  return (
    <section id="experience" className="experience" ref={ref}>
      <div className="container">
        <h2 className="section-title">Internship Experience</h2>
        <div className="experience-timeline">
          <div className="experience-item">
            <div className="experience-header">
              <h3 className="experience-title">Java Programming Intern</h3>
              <span className="experience-company">CodeAlpha (Remote)</span>
              <span className="experience-duration">Dec 2025 – Jan 2026</span>
            </div>
            <div className="experience-content">
              <h4 className="experience-category">Software Development (Java)</h4>
              <ul className="experience-details">
                <li>Developed four full-scale Java applications focusing on Object-Oriented Programming (OOP) principles and clean architecture.</li>
                <li>Implemented an AI Chatbot using Natural Language Processing (NLP) techniques and a custom GUI for real-time interaction.</li>
                <li>Designed a Hotel Reservation System featuring room categorization, booking management, and payment simulation logic.</li>
                <li>Built a Student Grade Tracker utilizing ArrayLists for dynamic data management and automated performance reporting.</li>
                <li>Integrated File I/O across projects to ensure permanent data storage and persistence.</li>
                <li>Utilized GitHub for version control, managing multiple project branches and following professional documentation standards.</li>
              </ul>

              <h4 className="experience-category">Key Technologies</h4>
              <div className="experience-technologies">
                <span className="tech-tag">Java</span>
                <span className="tech-tag">OOP</span>
                <span className="tech-tag">JavaFX</span>
                <span className="tech-tag">C++ (DSA)</span>
                <span className="tech-tag">File I/O</span>
                <span className="tech-tag">Git / GitHub</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default Experience;
